import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { ApiService } from '../../../api/api.service'
import { LoginResult, Method, Result, parseError } from '../../../shared/interfaces'
import { StorageService } from 'src/app/services/storage.service';
import { CoreService } from 'src/app/services/core-service/core-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  forma = new FormGroup({
    password: new FormControl('', Validators.minLength(8)),
    email: new FormControl('', { validators: [Validators.required, Validators.email] })
  });

  recuperacion = new FormGroup({
    email: new FormControl('', { validators: [Validators.required, Validators.email] })
  })
  public login: boolean = true;
  constructor(
    private ntf: ToastService,
    protected _apiService: ApiService,
    private storage: StorageService,
    public core: CoreService,
    private route: Router) {

  }

  async loguear() {
    try {
      this.core.lock()
      let path: string = '/auth/login'
      let metodo: Method = 'POST'
      const result = (await this._apiService.consulta(path, false, [], this.forma.value, metodo)).data as Result
      const data = result.data as LoginResult
      data.token.logueado = true
      this.storage.token = data.token
      this.storage.usuario = data.usuario
      this.ntf.success(result.message || 'Ingresado')
      this.route.navigate(['/home'])
    } catch (e) {
      this.ntf.error(`Error al loguearse: ${parseError(e) || ''}`)
      this.storage.storage.clear('token');
      this.storage.storage.clear('usuario');
    } finally {
      this.core.unlock()
    }
  }

  async mostrarNuevoPass() {
    this.login = false;
  }

  async mostrarLogin() {
    this.login = true;
  }

  async recuperarContrasena() {
    try {
      this.core.lock()
      let path: string = '/auth/recuperar'
      let metodo: Method = 'POST'
      const result = (await this._apiService.consulta(path, false, [], this.recuperacion.value, metodo)).data as Result
      this.ntf.success(result.message)
    } catch (e) {
      this.ntf.error(`${parseError(e) || ''}`)
    } finally {
      this.core.unlock()
    }
  }

}
